import StatePage from '../../components/StatePage/StatePage';

const NotFound = () => <StatePage icon="alert" eyebrow="Error 404" title="Esta página no existe" text="La dirección puede estar incompleta o la página pudo cambiar de ubicación." actionLabel="Volver al inicio" tone="error" />;

export default NotFound;
